import { userinfo } from './../../../Services/userinfo';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { mdlProposalSaveReq } from '../../../Models/mdlProposalSaveReq';
import { RiskDetails_DH } from '../../../Models/RiskDetails_DH';
import { restURL } from '../../../Models/restURL';
import { mdlBindInfoReq_DH } from '../../../Models/mdlBindInfoReq_DH';
import { userService } from '../../../Services/userService';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { motorProposalService } from '../../../Services/motorProposalService';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'DomesticInsuredInfo',
  templateUrl: './DomesticInsuredInfo.html',
  styleUrls: ['./DomesticInsuredInfo.css']
})
export class DomesticInsuredInfo {

  public isSubmitted: boolean = false;
  public minDate: Date = new Date();
  public maxDate: Date = new Date();
  public minAgeDate: Date = new Date();
  public maxAgeDate: Date = new Date();

  public objProposal: mdlProposalSaveReq = new mdlProposalSaveReq();
  public objRiskDetails: RiskDetails_DH = new RiskDetails_DH();
  public objBindInfoReq: mdlBindInfoReq_DH = new mdlBindInfoReq_DH();
  public Lng: string;
  public showLoading: boolean = false;

  constructor(public Translate: TranslateService, private EncriptService: motorProposalService, private userinfo: userService, private url: restURL, private router: Router, private http: HttpClient) {
    //sessionStorage.removeItem("DomesticProposal");
    if (sessionStorage.getItem("Language") != null) { this.Lng = sessionStorage.getItem("Language"); }
    else { this.Lng = "en"; }
    if (sessionStorage.getItem("DomesticProposal") != null) {
      this.objProposal = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("DomesticProposal")));
      if (this.objProposal.RiskDetails.length > 0)
        this.objRiskDetails = this.objProposal.RiskDetails[0];
        if(this.objProposal.Insured_PostalCode==0){this.objProposal.Insured_PostalCode = null}
    }
    else {
      this.BindInfo();
    }
    this.minDate.setDate(new Date().getDate() + 1);
    this.minDate = new Date(this.GetDate(this.minDate, ""));

    this.maxDate.setDate(new Date().getDate() + 915);
    this.maxDate = new Date(this.GetDate(this.maxDate, ""));

    this.maxAgeDate.setDate(new Date().getDate() - 3650);
    this.maxAgeDate = new Date(this.GetDate(this.maxAgeDate, ""));

  
  }

  Prev() {
    this.router.navigate(['NewDashboard/Welcome']);
  }

  GetDate(val, Val1): string {
    if (Val1 == "To") {
      var d = new Date(val),
        month = '' + (d.getMonth() + 1),
        day = '' + (d.getDate()),
        year = '' + (d.getFullYear() + 1);

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return year + "-" + month + "-" + day;
    }
    else {
      var d = new Date(val),
        month = '' + (d.getMonth() + 1),
        day = '' + (d.getDate()),
        year = '' + (d.getFullYear());

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return year + "-" + month + "-" + day;
    }
  }



  BindInfo() {
    this.showLoading = true;
    this.objBindInfoReq.Insured_IdNo = sessionStorage.getItem("IqamaNo");//"2045564024"//
    this.objBindInfoReq.RegNo = Number(sessionStorage.getItem("RegNo"));//411957//
    this.objBindInfoReq.LangFlag = sessionStorage.getItem("Language");


    this.http.post<mdlProposalSaveReq>(this.url.baseURL + "/DomesticHelper/BindInfo", this.objBindInfoReq, this.userinfo.getHttpOptions())
      .toPromise().then((result) => {
        this.showLoading = false;
        this.objProposal = result;
        if (this.objProposal.StatusCode == "S") {
          //this.objProposal.Insured_Profession = null
          this.objProposal.Insured_UnitNo = null
        }
        else {
          Swal(this.Translate.instant(this.objProposal.StatusDesc));
          this.router.navigate(['NewDashboard/Welcome']);
          return;
        }
      },
        (error) => {
          this.showLoading = false;
          Swal(JSON.stringify(error));
          this.router.navigate(['NewDashboard/Welcome']);
        });
  }
  cityChange(val) {
    this.objProposal.Insured_City_ArDesc = this.objProposal.CityMasterList.filter(t => t.CITYNAME = val)[0].CITYNAMEAr;
    this.objProposal.Insured_City_EnDesc = this.objProposal.CityMasterList.filter(t => t.CITYNAME = val)[0].CITYNAMEEn;
  }

  Next(insuredForm) {
   
    this.isSubmitted = true;
    if (!insuredForm.valid) {
      return;
    }
    this.objProposal.PolicyFromDate = new Date(this.GetDate(this.objProposal.PolicyFromDate, ""));
    this.objProposal.PolicyToDate = new Date(this.GetDate(this.objProposal.PolicyToDate, ""));
    this.objProposal.Insured_DOB=new Date(this.GetDate(this.objProposal.Insured_DOB, ""));
    this.objProposal.RiskDetails = new Array<RiskDetails_DH>();
   
    if(this.objRiskDetails.DOB==undefined){this.objRiskDetails.DOB=null}
    this.objProposal.RiskDetails.push(this.objRiskDetails); 
   
    sessionStorage.setItem("DomesticProposal", this.EncriptService.EncriptObject(JSON.stringify(this.objProposal)));
    //sessionStorage.setItem("DomesticProposal", JSON.stringify(this.objProposal));
    this.router.navigate(['NewDashboard/DomesticPremiumInfo']);
  }


  ValidateDOB(DOB) {

    var valid = moment(DOB, 'dd/mm/yyyy').isValid();
    var years = moment().diff(DOB, 'years');

    if (DOB == "Invalid date" || DOB == '' || DOB == null || DOB == "Invalid Date") {

      this.objRiskDetails.DOB = null;
    }
    else if (years > 100) {
      this.Lng == "en" ? Swal("Enter Valid Date") : Swal("أدخل تاريخ صالح");
      this.objRiskDetails.DOB = null;
    }
    else {
      if (this.objRiskDetails.DOB < this.minDate) {
        this.Lng == "en" ? Swal("Date Of Birth Must Be Less than Current Date") : Swal("تاريخ الميلاد يجب أن يكون أقل من التاريخ الحالي");
        this.objRiskDetails.DOB = null;
      }
    }

  }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/DomesticHelperPortal/DomesticInsuredInfo/DomesticInsuredInfo.ts